import { ReferenceHWState } from "../ReferenceHW/ReferenceHWState";
import { Nullable, Voidable } from "../../../types/aliases";
import { MLDemoHWStateProperties as MLDemoHWStateProperties } from "./MLDemoHWStateProperties";

export enum MLDemoIntervalTypes {
  MEASURE,
  UPDATE
}

export class MLDemoHWState extends ReferenceHWState<MLDemoHWStateProperties> {

  private static readonly DEFAULT_INTERVAL = 15;
  private static readonly MAX_INTERVAL = 3600;
  private static readonly MIN_UPDATE_INTERVAL = 0;
  private static readonly MIN_MEASUREMENT_INTERVAL = 5;

  public static toValidInterval(value: Voidable<number>, type: MLDemoIntervalTypes): number {
    if (value == null) {
      return MLDemoHWState.DEFAULT_INTERVAL;
    }

    if (value > MLDemoHWState.MAX_INTERVAL) {
      return MLDemoHWState.MAX_INTERVAL;
    }
    const min = MLDemoHWState.getMinIntervalValue(type);

    if (value < min) {
      return min;
    }
    return value;
  }

  public static getMinIntervalValue(type: MLDemoIntervalTypes): number {
    switch (type) {
      case MLDemoIntervalTypes.MEASURE:
        return this.MIN_MEASUREMENT_INTERVAL;
      case MLDemoIntervalTypes.UPDATE:
        return this.MIN_UPDATE_INTERVAL;
      default:
        return 0;
    }
  }

  public get noModemSleep(): Nullable<boolean> {
    return this.deltaExists("noModemSleep") ? this.desired.noModemSleep : this.reported.noModemSleep;
  }

  public set noModemSleep(enabled: Nullable<boolean>) {
    this.desired.noModemSleep = enabled;
    this.changedValues.noModemSleep = enabled;
  }

  public get updateInterval(): Nullable<number> {
    return this.deltaExists("updateInterval") ? this.desired.updateInterval : this.reported.updateInterval;
  }

  public set updateInterval(value: Nullable<number>) {
    const validatedValue = MLDemoHWState.toValidInterval(value, MLDemoIntervalTypes.UPDATE);
    this.desired.updateInterval = validatedValue;
    this.changedValues.updateInterval = validatedValue;
  }

  public get measurementInterval(): Nullable<number> {
    return this.deltaExists("measurementInterval") ? this.desired.measurementInterval : this.reported.measurementInterval;
  }

  public set measurementInterval(value: Nullable<number>) {
    const validatedValue = MLDemoHWState.toValidInterval(value, MLDemoIntervalTypes.MEASURE);
    this.desired.measurementInterval = validatedValue;
    this.changedValues.measurementInterval = validatedValue;
  }
}
